import { createAction } from "@logicsoftware/redux-toolkit";
import { call, takeLatest } from "redux-saga/effects";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";
import { callApi } from "~/Redux/Sagas/effects/callApi";
import { loadSpaces } from "~/Redux/Spaces/state/sagas/loadSpaces";

type Payload = { id: number; callback?: () => void };
export const archiveSpace = createAction<Payload>("SPACES/ARCHIVE");
export const unarchiveSpace = createAction<Payload>("SPACES/UNARCHIVE");

export function* watchArchiveSpace() {
    yield takeLatest(archiveSpace, function* ({ payload: { id, callback } }) {
        yield callApi(({ ajaxOptions }) =>
            OAuthClient.postJson(appUrls.spaces.archiveSpace, { SpaceId: id }, ajaxOptions)
        );

        yield reloadSpaces(callback);
    });

    yield takeLatest(unarchiveSpace, function* ({ payload: { id, callback } }) {
        yield callApi(({ ajaxOptions }) =>
            OAuthClient.postJson(appUrls.spaces.unarchiveSpace, { SpaceId: id }, ajaxOptions)
        );

        yield reloadSpaces(callback);
    });
}

function* reloadSpaces(callback: Payload["callback"]) {
    yield loadSpaces();
    yield call(() => callback?.());
}
